import { Grid, useMediaQuery } from '@mui/material';
import React, { useContext } from 'react'
import dashboardStyles from './../../../assets/styles/componentStyles/callAnalysisStyles/callAnalysisDashboard.module.scss'
import globalStyles from "../../../assets/styles/global.module.scss";
import styles from "../../../assets/styles/componentStyles/whatsappCampaignStyles/whatsappCampaignAnalysisStyle.module.scss";
import { PieChart } from '@mui/x-charts';
import { campaignContactAssignmentData, createCampaignResponse } from '../../../models/axiosModel';
import { WhatsappCampaignContext, WhatsappCampaignContextPayload } from '../../../context/whatsappCampaignContext';
import { thousandSeparator } from '../../../utils/constants';


interface CampaignAnalysisPieChartProps {
    fieldName: string,
    fieldData: createCampaignResponse,
    roundOffData: (numData: number, denData: number, flagCard?: boolean) => string,
    flagDashboardPage?: boolean,
}

interface campaignStatusData {
    campaign_status_key: string,
    campaign_status_show_value: string,
    campaign_status_value: number,
    campaign_status_percentage: string,
}

interface clickedReplyStatus {
    campaign_status_key: string,
    campaign_status_show_value: string,
    campaign_status_value: number,
    campaign_status_percentage: string,
}

const CampaignAnalysisPieChart: React.FC<CampaignAnalysisPieChartProps> = (props) => {
    const { selectedWhatsAppCampaign, messageTemplateDetail } = useContext(WhatsappCampaignContext) as WhatsappCampaignContextPayload
    let buttons = messageTemplateDetail?.whatsapp_template_data?.[0]?.whatsapp_template_button?.filter((allowed) => allowed.flag_allow_tracking) || []
    const { fieldName, fieldData, roundOffData, flagDashboardPage } = props;

    const campaignStatusData: campaignStatusData[] = [
        {
            campaign_status_key: "Sent",
            campaign_status_show_value: "Sent Contacts:",
            campaign_status_value: fieldData?.total_sent_campaign_contact || 0,
            campaign_status_percentage: roundOffData(fieldData?.total_sent_campaign_contact || 0, fieldData?.total_campaign_contact || 1)
        },
        {
            campaign_status_key: "Pending",
            campaign_status_show_value: "Pending Contacts:",
            campaign_status_value: fieldData?.total_pending_campaign_contact || 0,
            campaign_status_percentage: roundOffData(fieldData?.total_pending_campaign_contact || 0, fieldData?.total_campaign_contact || 1)
        },
        {
            campaign_status_key: "Failed",
            campaign_status_show_value: "Failed Contacts:",
            campaign_status_value: fieldData?.total_failed_campaign_contact || 0,
            campaign_status_percentage: roundOffData(fieldData?.total_failed_campaign_contact || 0, fieldData?.total_campaign_contact || 1)
        }
    ]

    // const clickedReplyStatus: clickedReplyStatus[] = [
    //     {
    //         campaign_status_key: "Clicked",
    //         campaign_status_value: fieldData?.total_contacts_who_clicked || 0,
    //         campaign_status_show_value: "Clicked",
    //     },
    //     {
    //         campaign_status_key: "Replied",
    //         campaign_status_value: 0,
    //         campaign_status_show_value: "Replied",
    //     },
    // ]

    const clickedReplyStatus: clickedReplyStatus[] = buttons?.map((track) => {
        let existingButton = track?.whatsapp_template_button_data?.[0]?.whatsapp_template_button_sub_type_field_data?.find((field) => field?.field_name?.toLowerCase() == "button text")?.whatsapp_template_button_sub_type_field_value?.toString();
        let count = 0;
        for (let i=0; i < (selectedWhatsAppCampaign?.campaign_contact_assignment_data?.length || 0) ; i++) {
            let logs = selectedWhatsAppCampaign?.campaign_contact_assignment_data?.[i]?.campaign_analytics_status
            if (logs && logs?.length > 0) {
                let trackCount = logs.filter((data) => data.whatsapp_template_button_id == track.whatsapp_template_button_id)
                if (trackCount && trackCount?.length > 0) {
                    let finalTrack = trackCount?.filter((track) => track.campaign_execution_status_name?.toLowerCase() == "clicked")
                    if (finalTrack && finalTrack?.length > 0) {
                        count += finalTrack?.length
                    }
                }
            }
        }

        return {
            campaign_status_key: existingButton || "",
            campaign_status_show_value: `${existingButton} Button Click:` || "",
            campaign_status_value: count || 0,
            campaign_status_percentage: roundOffData(count || 0, fieldData?.total_clicked_count || 1)
        }
    })

    const categories = fieldName === "Campaign Status" ? campaignStatusData.map((item: campaignStatusData) => `${item.campaign_status_show_value}`) : clickedReplyStatus.map((item: clickedReplyStatus) => `${item.campaign_status_show_value}`);
    const scores = fieldName === "Campaign Status" ? campaignStatusData.map((item: campaignStatusData) => item.campaign_status_value) : clickedReplyStatus.map((item: clickedReplyStatus) => item.campaign_status_value);

    const pieData = categories.map((category: string, index: number) => ({
        id: index,
        label: category,
        value: scores[index],
    }));

    // const complexityColor = ['#EAC5FF', '#81B2EC', '#A1E3CB', '#A8E0FF'];
    const campaignStatusColor = [
        {
            key: "Sent",
            value: fieldData?.total_sent_campaign_contact || 0,
            color: '#00A54A'
        },
        {
            key: "Pending",
            value: fieldData?.total_pending_campaign_contact || 0,
            color: '#DECC00'
        },
        {
            key: "Failed",
            value: fieldData?.total_failed_campaign_contact || 0,
            color: '#DF0000'
        },
    ];
    const clickedRepliedColor = ['#C55EFF', '#348AF0'];
    // const categoriesColor = ['#EAC5FF', '#81B2EC', '#A1E3CB', '#A8E0FF','#BAB3E2', '#CBD5E8', '#CCCCCC', '#F1E2CC', '#FFF2AE'];

    const pieParams = {
        slotProps: { legend: { hidden: true } }
    }

    const smallScreen = useMediaQuery('(max-width : 500px) and (min-width : 0px)');
    const tabletScreen = useMediaQuery('(max-width : 750px) and (min-width : 600px)');
    const largeScreen = useMediaQuery('(min-width : 1850px)');

    return (
        <Grid container direction={"column"} gap="10px" className={styles.pieChartContainer}>
            <Grid item className={globalStyles.fullwidth} marginTop={(flagDashboardPage && largeScreen)? "15px" : "0"}>
                <span className={dashboardStyles.pieChartHeadingName} style={{ whiteSpace: "nowrap" }}>
                    {fieldName === "Campaign Status" ? 
                        `${fieldName} (Contacts - ${thousandSeparator(fieldData?.total_campaign_contact)})` 
                        : 
                        `${fieldName} (Clicks - ${thousandSeparator(fieldData?.total_clicked_count)})`
                    }
                    {/* `${fieldName} (Delivered Contacts - ${fieldData?.total_delivered_campaign_contact})` */}
                </span>
            </Grid>
            <Grid item marginTop={(flagDashboardPage && largeScreen) ? "15px" : "0"}>
                <Grid container direction={"row"} alignItems={"center"} flexWrap={"nowrap"} gap={tabletScreen ? "0px" : "16px"}>
                    <Grid item xs={5.5} sm={6} sx={{ width: "100%" }} className={styles.pieContainer}>
                            <Grid item mt={{ lg: 2 }}>
                                <PieChart
                                    className={dashboardStyles.pieChartsStyle}
                                    height={smallScreen || tabletScreen ? 300 : 200}
                                    colors={fieldName === "Campaign Status" ? campaignStatusColor.filter((status) => status.value > 0).map((data) => data.color) : clickedRepliedColor}
                                    series={[
                                        {
                                            data: pieData.filter((pie) => pie.value > 0),
                                            innerRadius: 50,
                                            outerRadius: 100,
                                            paddingAngle: 2.5,
                                            cornerRadius: 5,
                                            startAngle: 0,
                                            endAngle: 360,
                                            highlightScope: { fade: 'global', highlight: 'item' },
                                            faded: { innerRadius: 30, additionalRadius: -30, color: 'gray' },
                                            cx: smallScreen || tabletScreen  ? 40 : 100,
                                            // cy: 150,
                                        }
                                    ]}
                                    {...pieParams}
                                />
                            </Grid>
                    </Grid>

                    <Grid item xs={6.5} sm={6} sx={{ width: "100%", maxHeight: "230px", overflow: "auto" }} className={styles.pieLabelContainer}>
                        <Grid container direction={"column"} gap={"4px"}>
                            {categories.map((category: string, index: number) =>
                                <Grid item key={index}>
                                    <Grid container direction={"row"} gap={2} alignItems={"center"} flexWrap={"nowrap"}>
                                        <Grid item className={dashboardStyles.labelCircle} style={{ backgroundColor: fieldName === "Campaign Status" ? campaignStatusColor[index].color : clickedRepliedColor[index] }}></Grid>
                                        <Grid item>
                                            <span className={dashboardStyles.labelHeading}>
                                                {fieldName === "Campaign Status" ? `${campaignStatusData.find((data) => data.campaign_status_show_value == category)?.campaign_status_key} (${campaignStatusData.find((data) => data.campaign_status_show_value == category)?.campaign_status_percentage})` 
                                                : 
                                                `${clickedReplyStatus.find((data) => data.campaign_status_show_value == category)?.campaign_status_key} (${clickedReplyStatus.find((data) => data.campaign_status_show_value == category)?.campaign_status_percentage})`}
                                            </span>
                                        </Grid>
                                    </Grid>
                                </Grid>
                            )}
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
        </Grid>
    )
}

export default CampaignAnalysisPieChart
